<template>
<div class="akl">

<!-- 레이어 팝업 : 뉴트리라이트 갱년기 자가진단 .pop_womanhealth -->
<div class="layerWrapper pop_womanhealth" tabindex="0" style="display: none;"><!-- @레이어 이름 -->
  <div class="cbox layerBox popWidM" style=""><!-- @팝업 사이즈 600px : popWidM -->
    <div class="cart-popup__dialog">
      <div class="cart-popup__header">
        <span class="cart-popup__header-text">
          뉴트리라이트 갱년기 자가진단
          <a href="#" data-dismiss="modal" aria-label="Close" aria-hidden="true" class="cart-popup_cc" v-show="showMode == 12" v-on:click="init"><img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/reload.png" alt="새로고침"></a>
        </span>
      </div>

      <!-- 01_intro -->
      <div v-show="showMode != 12" class="cart-popup__content height-auto">
        <div v-show="showMode == 0" class="content_womanhealth">
          <p class="wh_tit txtC">
            바쁜 일상 속에서 놓치고 있었던 내 몸의 신호!<br>
            <strong class="color_purple">갱년기 자가진단을 통해 나의 몸을 이해하고 갱년기를 적극적으로 관리해보세요!</strong>
          </p>
          <div class="txtC"><img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/vis01.jpg" alt=""></div>
          <p class="wh_txt txtC marB">
            MRS II(갱년기 정도 평가지수)*를 활용한
            갱년기 자가진단을 통해 나의 몸을 이해하고
            적극적으로 관리해보세요.
          </p>
          <p class="wh_comment">
            * MRS II(갱년기 정도 평가지수)란? : 갱년기 여성의 삶의 질을 평가하는 도구로 심리적 증상, 신체 증상, 비뇨 생식기 증상 등의 총 11개 문항으로 구성되며 각 문항에 대해서 0점(없음)에서 4점(매우 심함)의 점수로 평가합니다.<br>
            ※ 한국암웨이㈜는 본 설문조사에 대한 귀하의 자가진단 결과 정보를 별도로 수집하거나 이용하지 않습니다.
          </p>
        </div>

        <div v-show="0 < showMode && showMode < 12" class="content_womanhealth">
          <div v-show="showMode == 1" class="marB">
            <p class="wh_tit txtC">
              <b class="color_purple">1</b> / 11
            </p>
            <div class="txtC marB"><img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/q01.jpg" alt=""></div>
            <p class="wh_tit txtC"><b class="color_purple">
              얼굴에 갑자기 열감이 느껴지고 붉어지며,<br>
              갑작스럽게 땀이 난다.
            </b></p>
          </div>
          <!-- //질문 1 -->

          <div v-show="showMode == 2" class="marB">
            <p class="wh_tit txtC">
              <b class="color_purple">2</b> / 11
            </p>
            <div class="txtC marB"><img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/q02.jpg" alt=""></div>
            <p class="wh_tit txtC"><b class="color_purple">
              심장 불편감<sup><a href="#comment_q02" class="color_purple">*</a></sup>이 있다.
            </b></p>
            <p class="wh_comment txtC" id="comment_q02">
              * 갑자기 가슴이 두근거림, 맥박이 건너 뜀, 박동이 빨라짐, 가슴이 조여드는 느낌
            </p>
          </div>
          <!-- //질문 2 -->

          <div v-show="showMode == 3" class="marB">
            <p class="wh_tit txtC">
              <b class="color_purple">3</b> / 11
            </p>
            <div class="txtC marB"><img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/q03.jpg" alt=""></div>
            <p class="wh_tit txtC"><b class="color_purple">
              수면 문제<sup><a href="#comment_q03" class="color_purple">*</a></sup>를 겪는다.
            </b></p>
            <p class="wh_comment txtC" id="comment_q03">
              * 잠들기 어려움, 수면을 지속하기 어려움, 잠에서 이르게 깸
            </p>
          </div>
          <!-- //질문 3 -->

          <div v-show="showMode == 4" class="marB">
            <p class="wh_tit txtC">
              <b class="color_purple">4</b> / 11
            </p>
            <div class="txtC marB"><img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/q04.jpg" alt=""></div>
            <p class="wh_tit txtC"><b class="color_purple">
              우울한 기분<sup><a href="#comment_q04" class="color_purple">*</a></sup>이 든다.
            </b></p>
            <p class="wh_comment txtC" id="comment_q04">
              * 기분이 쳐짐, 슬픔, 쉽게 눈물이 남, 의욕 없음, 감정이 수시로 변함
            </p>
          </div>
          <!-- //질문 4 -->

          <div v-show="showMode == 5" class="marB">
            <p class="wh_tit txtC">
              <b class="color_purple">5</b> / 11
            </p>
            <div class="txtC marB"><img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/q05.jpg" alt=""></div>
            <p class="wh_tit txtC"><b class="color_purple">
              과민한 느낌<sup><a href="#comment_q05" class="color_purple">*</a></sup>이 든다.
            </b></p>
            <p class="wh_comment txtC" id="comment_q05">
              * 신경이 날카로워지는 느낌, 내적인 긴장감, 공격적으로 되는 느낌
            </p>
          </div>
          <!-- //질문 5 -->

          <div v-show="showMode == 6" class="marB">
            <p class="wh_tit txtC">
              <b class="color_purple">6</b> / 11
            </p>
            <div class="txtC marB"><img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/q06.jpg" alt=""></div>
            <p class="wh_tit txtC"><b class="color_purple">
              불안감<sup><a href="#comment_q05" class="color_purple">*</a></sup>을 느낀다.
            </b></p>
            <p class="wh_comment txtC" id="comment_q06">
              * 내적인 초조감, 공황상태가 되는 느낌
            </p>
          </div>
          <!-- //질문 6 -->

          <div v-show="showMode == 7" class="marB">
            <p class="wh_tit txtC">
              <b class="color_purple">7</b> / 11
            </p>
            <div class="txtC marB"><img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/q07.jpg" alt=""></div>
            <p class="wh_tit txtC"><b class="color_purple">
              신체 및 정신적 피로를 느낀다.
            </b></p>
          </div>
          <!-- //질문 7 -->

          <div v-show="showMode == 8" class="marB">
            <p class="wh_tit txtC">
              <b class="color_purple">8</b> / 11
            </p>
            <div class="txtC marB"><img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/q08.jpg" alt=""></div>
            <p class="wh_tit txtC"><b class="color_purple">
              성적 욕구나 성적 만족감의 변화가 있다.
            </b></p>
          </div>
          <!-- //질문 8 -->

          <div v-show="showMode == 9" class="marB">
            <p class="wh_tit txtC">
              <b class="color_purple">9</b> / 11
            </p>
            <div class="txtC marB"><img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/q09.jpg" alt=""></div>
            <p class="wh_tit txtC"><b class="color_purple">
              배뇨 문제<sup><a href="#comment_q04" class="color_purple">*</a></sup>를 겪는다.
            </b></p>
            <p class="wh_comment txtC" id="comment_q09">
              * 배뇨 어려움, 소변이 자주 마려움, 요실금 등
            </p>
          </div>
          <!-- //질문 9 -->

          <div v-show="showMode == 10" class="marB">
            <p class="wh_tit txtC">
              <b class="color_purple">10</b> / 11
            </p>
            <div class="txtC marB"><img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/q10.jpg" alt=""></div>
            <p class="wh_tit txtC"><b class="color_purple">
              질 건조감을 느낀다.
            </b></p>
          </div>
          <!-- //질문 10 -->

          <div v-show="showMode == 11" class="marB">
            <p class="wh_tit txtC">
              <b class="color_purple">11</b> / 11
            </p>
            <div class="txtC marB"><img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/q11.jpg" alt=""></div>
            <p class="wh_tit txtC"><b class="color_purple">
              관절 및 근육의 통증이나 불편감을 느낀다.
            </b></p>
          </div>
          <!-- //질문 11 -->

          <hr>

          <!-- 점수선택 -->
          <div>
            <div class="clearfix">
              <div class="fl20 pointC0"></div>
              <div class="fl20 pointC1"></div>
              <div class="fl20 pointC2"></div>
              <div class="fl20 pointC3"></div>
              <div class="fl20 pointC4"></div>
            </div>
            <div class="clearfix txtC amway-theme">
              <label class="fl20">
                <span class="amw-radio-wrap radio-label txtC focus">
                  <input type="radio" name="point" checked="checked" class="amw-global-radio" v-model="score" value="0">
                  <span class="amw-radio-overlay txtC"></span>
                </span>
                <span>0점</span>
                <img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/point01.png" alt="" style="max-width:20px">
                <span>전혀<br> 그렇지<br> 않다</span>
              </label>
              <!-- //0점 -->

              <label class="fl20">
                <span class="amw-radio-wrap radio-label txtC">
                  <input type="radio" name="point" class="amw-global-radio" v-model="score" value="1">
                  <span class="amw-radio-overlay txtC"></span>
                </span>
                <span>1점</span>
                <img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/point02.png" alt="" style="max-width:20px">
                <span>가끔<br> 그렇다</span>
              </label>
              <!-- //1점 -->

              <label class="fl20">
                <span class="amw-radio-wrap radio-label txtC">
                  <input type="radio" name="point" class="amw-global-radio" v-model="score" value="2">
                  <span class="amw-radio-overlay txtC"></span>
                </span>
                <span>2점</span>
                <img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/point03.png" alt="" style="max-width:20px">
                <span>종종<br> 그렇다</span>
              </label>
              <!-- //2점 -->

              <label class="fl20">
                <span class="amw-radio-wrap radio-label txtC">
                  <input type="radio" name="point" class="amw-global-radio" v-model="score" value="3">
                  <span class="amw-radio-overlay txtC"></span>
                </span>
                <span>3점</span>
                <img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/point04.png" alt="" style="max-width:20px">
                <span>자주<br> 그렇다</span>
              </label>
              <!-- //3점 -->

              <label class="fl20">
                <span class="amw-radio-wrap radio-label txtC">
                  <input type="radio" name="point" class="amw-global-radio" v-model="score" value="4">
                  <span class="amw-radio-overlay txtC"></span>
                </span>
                <span>4점</span>
                <img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/point05.png" alt="" style="max-width:20px">
                <span>매우<br> 자주<br> 그렇다</span>
              </label>
              <!-- //4점 -->
            </div>

          </div>
          <!-- //점수선택 -->

        </div>
      </div>

      <!-- 04_result 결과 확인하기 -->
      <div v-show="showMode == 12" class="cart-popup__content womanhealth_result">
        <div class="content_womanhealth">
          <p class="wh_tit color_purple txtC padT"><strong>
            나의 갱년기 건강 분석 결과 확인하기
          </strong></p>

          <hr>

          <div v-show="sum < 5" class="txtC padT marB">
            <p class="wh_txt">
              나의 갱년기 상태
            </p>
            <p class="wh_tit">
              <strong class="color_result01">갱년기 증상 거의 없음</strong>
            </p>
            <div><img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/result01.jpg" alt=""></div>
          </div>

          <div v-show="4 < sum && sum < 9" class="txtC padT marB">
            <p class="wh_txt">
              나의 갱년기 상태
            </p>
            <p class="wh_tit">
              <strong class="color_result02">경미한 갱년기 상태</strong>
            </p>
            <div><img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/result02.jpg" alt=""></div>
          </div>

          <div v-show="8 < sum && sum < 16" class="txtC padT marB">
            <p class="wh_txt">
              나의 갱년기 상태
            </p>
            <p class="wh_tit">
              <strong class="color_result03">중증도의 갱년기 상태</strong>
            </p>
            <div><img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/result03.jpg" alt=""></div>
          </div>

          <div v-show="15 < sum" class="txtC padT marB">
            <p class="wh_txt">
              나의 갱년기 상태
            </p>
            <p class="wh_tit">
              <strong class="color_result04">극심한 갱년기 상태</strong>
            </p>
            <div><img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/result04.jpg" alt=""></div>
          </div>

          <div v-show="sum < 5" class="marB txtC" style="border:1px solid #dadada;padding:20px">
            <p class="wh_txt">나의 갱년기 증상 점수</p>
            <p class="wh_txt"><span class="wh_tit"><strong class="color_result01">{{sum}}</strong></span> 점</p>
          </div>
          <!-- //점수 -->

          <div v-show="4 < sum && sum < 9" class="marB txtC" style="border:1px solid #dadada;padding:20px">
            <p class="wh_txt">나의 갱년기 증상 점수</p>
            <p class="wh_txt"><span class="wh_tit"><strong class="color_result02">{{sum}}</strong></span> 점</p>
          </div>
          <!-- //점수 -->

          <div v-show="8 < sum && sum < 16" class="marB txtC" style="border:1px solid #dadada;padding:20px">
            <p class="wh_txt">나의 갱년기 증상 점수</p>
            <p class="wh_txt"><span class="wh_tit"><strong class="color_result03">{{sum}}</strong></span> 점</p>
          </div>
          <!-- //점수 -->

          <div v-show="15 < sum" class="marB txtC" style="border:1px solid #dadada;padding:20px">
            <p class="wh_txt">나의 갱년기 증상 점수</p>
            <p class="wh_txt"><span class="wh_tit"><strong class="color_result04">{{sum}}</strong></span> 점</p>
          </div>
          <!-- //점수 -->

          <div v-show="sum < 5" class="clearfix marB txtC" style="border:1px solid #dadada;padding:20px">
            <div class="fl50">
              <p class="wh_txt">평균점수</p>
              <p><span class="wh_tit"><strong>14</strong> </span>점<sup><a href="#comment02">*</a></sup></p>
            </div>
            <div class="fl50">
              <div><img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/point01.png" alt="" style="max-width:20px"></div>
              <p><span class="wh_tit"><strong class="color_result01">{{sum-14}}</strong> </span>점</p>
            </div>
          </div>
          <!-- //평균점수 -->

          <div v-show="4 < sum && sum < 9" class="clearfix marB txtC" style="border:1px solid #dadada;padding:20px">
            <div class="fl50">
              <p class="wh_txt">평균점수</p>
              <p><span class="wh_tit"><strong>14</strong> </span>점<sup><a href="#comment02">*</a></sup></p>
            </div>
            <div class="fl50">
              <div><img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/point02.png" alt="" style="max-width:20px"></div>
              <p><span class="wh_tit"><strong class="color_result02">{{sum-14}}</strong> </span>점</p>
            </div>
          </div>
          <!-- //평균점수 -->

          <div v-show="8 < sum && sum < 16" class="clearfix marB txtC" style="border:1px solid #dadada;padding:20px">
            <div class="fl50">
              <p class="wh_txt">평균점수</p>
              <p><span class="wh_tit"><strong>14</strong> </span>점<sup><a href="#comment02">*</a></sup></p>
            </div>
            <div class="fl50">
              <div><img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/point03.png" alt="" style="max-width:20px"></div>
              <p><span class="wh_tit"><strong class="color_result03">{{sum-14}}</strong> </span>점</p>
            </div>
          </div>
          <!-- //평균점수 -->

          <div v-show="15 < sum" class="clearfix marB txtC" style="border:1px solid #dadada;padding:20px">
            <div class="fl50">
              <p class="wh_txt">평균점수</p>
              <p><span class="wh_tit"><strong>14</strong> </span>점<sup><a href="#comment02">*</a></sup></p>
            </div>
            <div class="fl50">
              <div><img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/point04.png" alt="" style="max-width:20px"></div>
              <p><span class="wh_tit"><strong class="color_result04">{{sum-14}}</strong> </span>점</p>
            </div>
          </div>
          <!-- //평균점수 -->

          <p class="wh_comment">
            * 김지현 등, 폐경기 여성의 갱년기 증상과 인지기능 감퇴와의
            관계 : 건강증진행위의 매개효과, Korean Journal of Adult
            Nursing Vol.29 No.2, 200-210, April 2017
          </p>
        </div>
        <!-- //결과 -->

        <div class="content_womanhealth">
          <p class="wh_tit color_purple txtC padT"><strong>
            갱년기 증상 Top 3<sup><a href="#comment02" class="color_purple">*</a></sup>
          </strong></p>

          <hr>

          <ol class="clearfix txtC">
            <li class="fl33">
              <div><img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/best01.jpg" alt=""></div>
              <p class="wh_txt padT">1위</p>
              <p class="wh_tit"><b class="color_purple">수면 문제</b></p>
            </li>
            <li class="fl33">
              <div><img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/best02.jpg" alt=""></div>
              <p class="wh_txt padT">2위</p>
              <p class="wh_tit"><b class="color_purple">피로감</b></p>
            </li>
            <li class="fl33">
              <div><img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/best03.jpg" alt=""></div>
              <p class="wh_txt padT">3위</p>
              <p class="wh_tit"><b class="color_purple">안면홍조</b></p>
            </li>
          </ol>
          <p class="wh_comment padT" id="comment02">* Chuni and Sreeramareddy BMC Women’s Health 2011, 11:30</p>
        </div>
        <!-- //증상 Top3 -->

        <div class="content_womanhealth">
          <p class="wh_tit color_purple txtC padT"><strong>
            갱년기 증상 점수에 따른 갱년기 상태
          </strong></p>

          <hr>

          <table class="wh_table">
            <caption>
              점수 별 상태
            </caption>
            <tbody>
              <tr>
                <th scope="row" style="background-color:#d0e9e2">
                  0~4점
                </th>
                <td>
                  <p class="color_result01">갱년기 증상 거의 없음</p>
                </td>
              </tr>
              <tr>
                <th scope="row" style="background-color:#e8f1cd">
                  5~8점
                </th>
                <td>
                  <p class="color_result02">경미한 갱년기 상태</p>
                </td>
              </tr>
              <tr>
                <th scope="row" style="background-color:#fdeac8">
                  9~15점
                </th>
                <td>
                  <p class="color_result03">중증도의 갱년기 상태</p>
                </td>
              </tr>
              <tr>
                <th scope="row" style="background-color:#f7d9d2">
                  16점 이상
                </th>
                <td>
                  <p class="color_result04">극심한 갱년기 상태</p>
                </td>
              </tr>

            </tbody>
          </table>
        </div>
        <!-- //갱년기 상태 -->
      </div>
      <div v-show="showMode != 12" class="cart-popup__item-link">
        <button v-show="showMode == 0" type="button" class="bt-akl-blue bt-whpop-purple" :style="{width:'90%'}" @click="start">자가진단 시작!</button>
        <button v-show="showMode > 1 && showMode < 12" type="button" class="bt-akl-blue bt-whpop-gray" @click="goBack">이전</button>
        <button v-show="showMode > 0 && showMode < 11" type="button" class="bt-akl-blue bt-whpop-purple" :style="{width:showMode==1?'90%':''}" @click="goNext">다음</button>
        <button v-show="showMode == 11" type="button" class="bt-akl-blue bt-whpop-purple" @click="goResult">결과 확인하기</button>
      </div>
      <!-- //01_intro -->

    </div>
  </div>
</div>
<!-- //레이어 팝업 : 뉴트리라이트 갱년기 자가진단 .pop_womanhealth -->

</div><!-- //.akl -->
</template>

<script>
import Vue from 'vue'
import $ from 'jquery'
import 'bootstrap'

export default {
  name: 'self-diagnosis',
  data () {
    return {
      showMode: 0,
      sum: 0,
      score: '',
      selectedScore:['','','','','','','','','','','']
    }
  },
  methods: {
    init: function () {
      this.showMode = 0
      this.sum = 0
      this.score = ''
      this.selectedScore = ['','','','','','','','','','','']
    },
    start:function () {
      this.score = ''
      this.selectedScore = ['','','','','','','','','','','']
      this.showMode = 1
    },
    goNext:function () {
      if(this.score){
        this.selectedScore[this.showMode-1] = this.score
        this.score = this.selectedScore[this.showMode]
        this.showMode = this.showMode + 1
      }
    },
    goBack:function () {
      this.showMode = this.showMode - 1
      this.score = this.selectedScore[this.showMode-1]
    },
    goResult:function () {
      if(this.score){
        this.selectedScore[this.showMode-1] = this.score
        let total = 0
        this.selectedScore.forEach(function(score) {
          total += parseInt(score)
        })
        this.sum = total
        this.showMode = parseInt(this.showMode) + 1
      }
    },
    goRoulette:function () {
      // window.location.href = process.env.ROULETTE_URL // 2020-05-12 외부연결제거
    }
  },
  mounted: function () {
    var varUA = navigator.userAgent.toLowerCase()
    if ( varUA.indexOf('amway') > -1 ) {
      if ( varUA.indexOf('android') > -1 ) {
        window.browser.browserConnect(process.env.SELF_DIAGNOSIS_URL)
      }
    }
    $(document).ready(function () {
      // 팝업 닫기 중복호출로 인해서 다른방식으로 구현
      $(".cart-popup_cc").addClass('cart-popup__close');
    })

  },
  created: async function () {

    await Vue.loadScript('https://www.amway.co.kr/_ui/responsive/common/js/jquery-3.2.1.min.js')
    await Vue.loadScript('https://www.amway.co.kr/_ui/responsive/common/js/jquery-ui-1.12.1.min.js')
    await Vue.loadScript('https://www.amway.co.kr/_ui/responsive/common/js/jquery.colorbox-min.js')
    await Vue.loadScript('https://www.amway.co.kr/_ui/responsive/common/js/jquery.flexslider.js')

    await Vue.loadScript('https://www.amway.co.kr/_ui/responsive/common/js/owl.carousel.js')
    await Vue.loadScript('https://www.amway.co.kr/_ui/responsive/common/js/owl.carousel.custom.js')
    await Vue.loadScript('https://www.amway.co.kr/_ui/responsive/common/js/bootstrap.min.js')
    await Vue.loadScript('https://www.amway.co.kr/_ui/responsive/common/js/swiper.min.js')

    await Vue.loadScript('https://www.amway.co.kr/_ui/responsive/common/js/common/akl_common.js')
    await Vue.loadScript('https://www.amway.co.kr/_ui/responsive/common/js/common/akl_contents.js')
    $(function(){
      layerPopOver('','.pop_womanhealth');
    });
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Noto+Sans+KR:300,400,500,700&subset=korean');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/style.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/akl-lib.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/base.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/akl-common.css');

@import 'font_kr.css';
.bt-whpop-gray{background-color:gray !important;border-color:gray !important;color:#fff !important;width:45%}
.bt-whpop-purple{width:45%}
</style>



// WEBPACK FOOTER //
// src/views/nutrilite/self-diagnosis/index.vue